import React from 'react';
import BaseTextareaAutosize from 'react-textarea-autosize';
import styled, { css } from 'styled-components';
import { body } from '../Typography';

const TextareaAutosize = styled(
  ({ showResizeIcon: _showResizeIcon, textAreaRef, autofocus, error: _error, ...rest }) => {
    const props = {
      ...(textAreaRef ? { ref: textAreaRef } : {}),
      ...(autofocus ? { autoFocus: true } : {}),
      ...rest
    };
    return <BaseTextareaAutosize {...props} />;
  }
).attrs(() => ({ className: 'textarea-autosize' }))`
  ${body};

  border-radius: 2px;
  width: ${({ enablePreviewModal }) => (enablePreviewModal ? '90%' : '100%')};
  border: 1px solid ${({ theme }) => theme.colors.grey2};
  outline: 0;
  padding: 10px;
  background: ${({ theme }) => theme.colors.white};
  min-height: 44px;
  resize: vertical;

  ${({ theme, error }) => error && `border-color: ${theme.colors.redNegative};`}
  ${({ showResizeIcon }) => !showResizeIcon && 'resize: none'};

  &:disabled {
    color: ${({ theme }) => theme.colors.grey3};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.grey3};
  }

  &:read-only {
    background: transparent;
  }

  ${({ $isPreview, theme }) =>
    $isPreview &&
    css`
      background-color: ${theme.colors.grey1};
      border: none;
      padding: 20px;
      width: 100%;

      &:hover {
        background-color: ${theme.colors.grey1} !important;
      }
    `};
`;

export default TextareaAutosize;
